module.exports = __webpack_public_path__ + "media/images/challenges/talent-league-iv/video-5997074b34ff55cb359c05377ca07d7e.svg";